export enum Slug {
  base = 'de-basis',
  summary = 'samenvatting',
  userWishes = 'eigen-woonwensen',
}
